// https://vuex.vuejs.org/en/actions.html
import axios from 'axios'
import jwtDecode from 'jwt-decode'

// The login action passes vuex commit helper that we will use to trigger mutations.
export default {
  login ({ commit }, userData) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      axios
        .post('user/signin', {
          email: userData.email,
          password: userData.password
        })
        .then((response) => {
          const token = response.data.token
          // const user = userData.email;
          // console.log(response);
          var decoded = jwtDecode(token)
          // console.log(decoded.role);
          if (decoded.role === 2) {
            // storing jwt in localStorage. https cookie is safer place to store
            const user = decoded.email
            localStorage.setItem('token', token)
            localStorage.setItem('user', decoded.email)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            // mutation to change state properties to the values passed along
            commit('auth_success', { token, user })
            resolve(response)
          } else {
            // user role error
            commit('auth_error')
            localStorage.removeItem('token')
            reject(new Error(400))
          }
        })
        .catch((err) => {
          // console.log(err);
          commit('auth_error')
          localStorage.removeItem('token')
          reject(err.response.status)
        })
    })
  },
  signup ({ commit }, userData) {
    return new Promise((resolve, reject) => {
      let signUpObject = {}
      signUpObject.firstname = userData.firstname
      signUpObject.lastname = userData.lastname
      signUpObject.email = userData.email
      signUpObject.password = userData.password
      signUpObject.phone = userData.phone
      if (userData.address !== undefined && userData.address !== '') {
        signUpObject.address = userData.address
      }
      if (userData.supplynumber !== undefined && userData.supplynumber !== '') {
        signUpObject.supply_number = userData.supplynumber
      }
      if (userData.kwhprice !== undefined && userData.kwhprice !== '') {
        signUpObject.kwh_price = userData.kwhprice
      }
      if (userData.termsCheckbox !== undefined) {
        signUpObject.accepted_terms = userData.termsCheckbox
      }
      if (userData.extraTermsCheckbox !== undefined) {
        signUpObject.accepted_extra_terms = userData.extraTermsCheckbox
      }
      if (userData.afm !== undefined && userData.afm !== '') {
        signUpObject.afm = userData.afm
      }
      if (userData.affiliation !== undefined && userData.affiliation !== '') {
        signUpObject.affiliation = userData.affiliation
      }

      axios
        .post('/user/signup', signUpObject)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          // commit("auth_error");
          // localStorage.removeItem("token");
          reject(err.response.status)
        })
    })
  },
  validateAcceptTermsToken ({ commit }, token) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/user/accept-terms-validate?token=${token}`)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err.response.status)
        })
    })
  },
  updateTerms ({ commit }, termsData) {
    return new Promise((resolve, reject) => {
      let termsObject = {}
      if (termsData.termsCheckbox !== undefined) {
        termsObject.accepted_terms = termsData.termsCheckbox
      }
      if (termsData.extraTermsCheckbox !== undefined) {
        termsObject.accepted_extra_terms = termsData.extraTermsCheckbox
      }

      axios
        .patch(
          `/user/accept-terms-update?token=${termsData.terms_token}`,
          termsObject
        )
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err.response.status)
        })
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout')
      localStorage.removeItem('token')
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  },
  refreshtoken ({ commit }) {
    axios
      .get('/refresh')
      .then((response) => {
        const token = response.data.access_token
        localStorage.setItem('token', token)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        commit('auth_success', { token })
      })
      .catch((error) => {
        console.log('refresh token error')
        commit('logout')
        localStorage.removeItem('token')
        console.log(error)
      })
  },
  // getTableList({ commit }, tableName) {
  //   this.$http
  //     .get(`/${tableName}`)
  //     .then((response) => {
  //       console.log(response);
  //       let tableList = response.data.Keys;
  //       commit("setTableList", { tableList });
  //     })
  //     .catch((error) => console.log(error));
  // },
  // updateTableItem({ commit }, tableData) {
  //   return new Promise((resolve, reject) => {
  //     let httpmethod = tableData.method;
  //     axios({
  //       url: `/${tableData.endpoint}`,
  //       method: httpmethod,
  //       data: tableData.tableItem,
  //     })
  //       .then((response) => {
  //         resolve(response);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         reject(error);
  //       });
  //   });
  // },
  deleteDevice ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod
      })
        .then((response) => {
          localStorage.setItem('token', response.headers.token)
          // console.log("resp: ", response.headers);
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  addDevice ({ commit }, tableData) {
    // console.log(tableData);
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          localStorage.setItem('token', response.headers.token)
          // console.log("resp: ", response.headers);
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  editDevice ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          localStorage.setItem('token', response.headers.token)
          // console.log("resp: ", response.headers);
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },

  deleteHome ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod
      })
        .then((response) => {
          localStorage.setItem('token', response.headers.token)
          // console.log("resp: ", response.headers);
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  addHome ({ commit }, tableData) {
    // console.log(tableData);
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          localStorage.setItem('token', response.headers.token)
          // console.log("resp: ", response.headers);
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  editHome ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          localStorage.setItem('token', response.headers.token)
          // console.log("resp: ", response.headers);
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },

  editUser ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          localStorage.setItem('token', response.headers.token)
          // console.log("resp: ", response.headers);
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  deleteUser ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod
      })
        .then((response) => {
          localStorage.setItem('token', response.headers.token)
          // console.log("resp: ", response.headers);
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  approveUser ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod
      })
        .then((response) => {
          localStorage.setItem('token', response.headers.token)
          // console.log("resp: ", response.headers);
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },

  deleteProject ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          localStorage.setItem('token', response.headers.token)
          // console.log("resp: ", response.headers);
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  addProject ({ commit }, tableData) {
    // console.log("old token: ", localStorage.getItem("token"));
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({
        url: `${tableData.endpoint}`,
        method: httpmethod,
        data: tableData.tableItem
      })
        .then((response) => {
          localStorage.setItem('token', response.headers.token)
          // console.log("resp: ", response.headers);
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  }

  // autoRefreshToken ({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     setInterval(function () {
  //       // code goes here that will be run every 20 minutes.
  //       axios.get('/refresh')
  //         .then(response => {
  //           const token = response.data.access_token
  //           localStorage.setItem('token', token)
  //           axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  //           commit('auth_success', { token })
  //           resolve(response)
  //         })
  //         .catch(error => {
  //           console.log('refresh token error')
  //           console.log(error)
  //           reject(error)
  //         })
  //     }, 1200000)
  //   }
  //   )
  // },
}
